export default __webpack_public_path__ + "static/media/Estimate_01.2036c75e.png";